import { v4 as uuidv4 } from 'uuid';

export function deleteInActiveSubscriptions ({ subscription }) {
    const newSubscriptions = this.subscriptions.filter((item) => {
        return (item.id !== subscription.id);
    })

    this.subscriptions = newSubscriptions;
    this.observed.subscriptions = uuidv4();
}